module.exports = __webpack_public_path__ + "static/media/news.4f42a4cb.gif";